/**
 * 시험결과 확인 표 — 행(시험항목)별 시료 값을 «열(검체명) 순서» 에 시료번호로 맞춘다.
 *
 * 배경(2026-10-27, EG-2610020 페놀류): 표는 각 행의 sampleList 를 위치(index)로 검체명 열에 넣는다.
 * 열 순서는 첫 시험항목의 sampleList 순서인데, 시험방법 변경(페놀 추출법↔직접법)으로 다시 저장된
 * 시료는 그 시험항목에서만 맨 뒤로 와 값이 한 칸씩 어긋났다(1번 직접법 값이 3-1번 열에 표시).
 * 서버도 시료 순서로 정렬하도록 고쳤지만(etps-server), 화면은 위치가 아니라 시료번호로 맞춰 넣어
 * 순서가 어긋나는 다른 경우에도 값이 다른 시료 열에 들어가지 않게 한다.
 *
 * 순수 함수라 webpack 과 node 테스트(scripts/*.test.js) 양쪽에서 쓴다 (fixedDigit 과 같은 CJS 형식).
 */

/** 시료 키: 시료번호(보이지 않는 공백·nbsp 제거) → 없으면 시료명 */
function sampleKey(sample) {
	if (!sample) return '';
	const no = String(sample.no ?? '').replace(/[​-‍﻿ ]/g, '').trim();
	if (no) return no;
	return String(sample.name ?? '').trim();
}

/**
 * @param {Array} sampleList 한 행의 시료 값 목록
 * @param {Array} columns    열 순서가 되는 시료 목록 (첫 시험항목의 sampleList)
 * @returns {Array} columns 순서로 맞춘 목록. 열에 없는 시료는 '-', 열에 없는 값은 뒤에 그대로 붙인다.
 */
function alignSampleListToColumns(sampleList, columns) {
	if (!Array.isArray(sampleList) || !Array.isArray(columns) || columns.length === 0) return sampleList;
	const queues = new Map();
	sampleList.forEach((s) => {
		const k = sampleKey(s);
		if (!queues.has(k)) queues.set(k, []);
		queues.get(k).push(s);
	});
	const aligned = columns.map((col) => {
		const q = queues.get(sampleKey(col));
		if (q && q.length) return q.shift();
		return { no: col?.no, name: col?.name, value: '-' };
	});
	queues.forEach((q) => aligned.push(...q));
	return aligned;
}

module.exports = { sampleKey, alignSampleListToColumns };
